import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  pageTitle = "Leone Lifestyle | La nuova era della nutrizione e del benessere";
  desc = "Nutrizione e Dieta Chetogenetica"
  shareImg = "share.jpg";
  
  constructor(private seo: SEOService) {}
  
  ngOnInit() { 
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

  clients = [
    {
      id: 'L-Detox',
      src: 'assets/L-Detox.jpg',
      title: 'L-Detox',
      url: 'https://shop.leonelifestyle.com/prodotti/protocollo-dimagrante/l-detox-200ml'
    },
    {
      id: 'L-Amino',
      src: 'assets/L-Amino.jpg',
      title: 'L-Amino',
      url: 'https://shop.leonelifestyle.com/categoria-prodotto/integratori/'
    },
    {
      id: 'L-Drena',
      src: 'assets/L-Drena.jpg',
      title: 'L-Drena',
      url: 'https://shop.leonelifestyle.com/prodotti/protocollo-dimagrante/l-drena-200ml'
    }
  ]

  //IMAGES BLOCK
  homePhotos = [
    {
      name: "BEAUTY",
      src: "assets/beauty-img.jpg",
      title: "Beauty - Leone Lifestyle"
    },
    {
      name: "WELLNESS",
      src: "assets/wellness-img.jpg",
      title: "Wellness - Leone Lifestyle"
    },
    {
      name: "WEIGHT CONTROL",
      src: "assets/weightcontrol-img.jpg",
      title: "Weight Control - Leone Lifestyle"
    }
  ]

  //TOPICS
  homeTopics = [
    {
      name: "",
      src: "assets/in-evidenza/_4/in-evidenza_4_home.jpg",
      title: "In Evidenza - Riccardo Ferrero Leone con Giorgio Calabrese",
      desc: "Il dottor Riccardo Ferrero Leone spiega la validità della dieta chetogenica al professor Giorgio Calabrese.",
      url: "in-evidenza/leone-con-calabrese",
      cta: "Continua a leggere"
    },
    {
      name: "",
      src: "assets/in-evidenza/_3/in-evidenza_3_home.jpg",
      title: "Amido Resistente - Un nutriente molto prezioso per la nostra salute",
      desc: "L’amido resistente (o resistant starch RS) è considerato una fibra alimentare che sfugge alla digestione e all’assorbimento intestinale ...",
      url: "in-evidenza/amido-resistente",
      cta: "Continua a leggere"
    },
    {
      name: "",
      src: "assets/in-evidenza/_2/in-evidenza_2_home.jpg",
      title: "Donazione Kerala",
      desc: "A giugno scorso il dottor Riccardo Ferrero Leone ha donato un ventilatore polmonare ad alto flusso con controllo automatico delle apnee ...",
      url: "in-evidenza/donazione-kerala",
      cta: "Continua a leggere"
    },
    // {
    //   name: "",
    //   src: "assets/in-evidenza/_0/in-evidenza_0_home.jpg",
    //   title: "In Evidenza - L-IMMUNO",
    //   desc: "È finalmente disponibile la formulazione <strong>antiossidante</strong> con <strong>Lattoferrina</strong> e <strong>Quercetina</strong> che protegge e rinforza il tuo sistema immunitario, utile per tutti ...",
    //   url: "in-evidenza/l-immuno",
    //   cta: "Continua a leggere"
    // },
    {
      name: "",
      src: "assets/in-evidenza/_1/in-evidenza_1_home.jpg",
      title: "In Evidenza - Leone Lifestyle",
      desc: "Il dottor Ferrero Leone ha ricevuto dal Ministro della Salute e dell’Ambiente della Repubblica dell’Iraq ...",
      url: "in-evidenza/ferrero-leone-alta-formazione",
      cta: "Continua a leggere"
    }
  ]

  homeTopics_riga2 = [
    {
      name: "IN EVIDENZA",
      src: "assets/in-evidenza//in-evidenza_home.jpg",
      title: "In Evidenza",
      desc: " Leggi tutte le notizie in evidenza del mondo che ruota attorno a Leone Lifestyle ...",
      url: "in-evidenza",
      cta: "Continua a leggere"
    },
    {
      name: "APPROFONDIMENTI",
      src: "assets/approfondimenti/approfondimenti_home.jpg",
      title: "Approfondimenti - Leone Lifestyle",
      desc: "Articoli, testi e notizie del mondo che ruota attorno alla dieta chetogenica ...",
      url: "approfondimenti",
      cta: "Continua a leggere"
    },
    {
      name: "PARTNER",
      src: "assets/partner/partners_home.jpg",
      title: "Partner - Leone Lifestyle",
      desc: "I Professionisti della salute e del benessere in Italia dove trovi la massima competenza ...",
      url: "partner",
      cta: "Continua a leggere"
    }
  ]

  //I NUOVI ARTICOLI VANNO INSERITI IN TESTA!
  homeArticles = [
    {
      title: "GLICOGENOSI DI TIPO V UNA SPERANZA CONCRETA ARRIVA DALLA CHETOGENICA",
      author: "DAVIDE GHIARA - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> MARTEDÌ 6 LUGIO 2021",
      section: "#DIETA CHETOGENICA",
      section_1: "#GLICOGENOSI",
      section_2: "#LEONELIFESTYLE",
      src: "assets/blog/glicogenosi-tipo-4-thumb.jpg",
      url: "blog/glicogenosi-tipo-4"
    },
    {
      title: "CHETOGENICA E TESTOSTERONE",
      author: "RICCARDO FERRERO LEONE - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> MERCOLEDÌ 26 MAGGIO 2021",
      section: "#DIETA CHETOGENICA",
      section_1: "#NUTRIZIONE CHETOGENICA",
      section_2: "#LEONELIFESTYLE",
      src: "assets/blog/chetogenica-e-testosterone-thumb.jpg",
      url: "blog/chetogenica-e-testosterone"
    },
    {
      title: "SVUOTIAMO LE TERAPIE INTENSIVE",
      author: "RICCARDO FERRERO LEONE - <br class='d-xl-none d-lg-none d-md-block d-sm-block d-block'> GIOVEDÌ 1 APRILE 2021",
      section: "#AUTOIMMUNITÀ",
      section_1: "#LEONELIFESTYLE",
      src: "assets/blog/svuotiamo-le-terapie-intensive-thumb.jpg",
      url: "blog/svuotiamo-le-terapie-intensive"
    }
  ]

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    nav: false,
    autoplay: true,
    navSpeed: 500,
    margin: 15,
    items: 1,
    dotsEach: 1
  }

  now = new Date().getFullYear()
}
